//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    /** @return {import('vue-meta').MetaInfo} */
    head() {
        return this.$nuxtI18nHead({ addSeoAttributes: true });
    },
    computed: {
        /** @return {TIDAL.UserInfo?} */
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
};
